// Gatsby copies static/font/* to public/font/* (not public/static/font/*).
const prefix = typeof __PATH_PREFIX__ !== 'undefined' ? __PATH_PREFIX__ : ''
const fontPath = (relativePath) => `${prefix}/font/${relativePath}`

const avertaStdRegular = fontPath('AvertaStdRegular/font.woff')
const avertaStdSemibold = fontPath('AvertaStdSemibold/font.woff')
const avertaStdBold = fontPath('AvertaStdBold/font.woff')
const dinProMedium = fontPath(
  'DINProMedium/4ba8e512-e6fb-494f-afd3-a7b68b2e5efb.woff'
)
const dinProRegular = fontPath('DINProRegular/DIN-Pro-Regular.woff')
const dinProBold = fontPath('DINProBold/DIN-Pro-Bold.woff')
const dinProBlack = fontPath('DINProBlack/DIN-Pro-Black.woff')

const criticalFontPreloadPaths = [avertaStdRegular, dinProMedium]

module.exports = {
  avertaStdRegular,
  avertaStdSemibold,
  avertaStdBold,
  dinProMedium,
  dinProRegular,
  dinProBold,
  dinProBlack,
  criticalFontPreloadPaths,
}
